import styled, { css } from 'styled-components';

export const Container = styled.section`
  ${({ theme }) => css`
    max-width: ${theme.layout.spacing(50)};

    background-color: ${theme.palette.neutral[50]};
    padding: ${theme.layout.spacing(3, 4)};

    border-radius: 16px;

    display: flex;
    flex-direction: column;
    gap: ${theme.layout.spacing(2)};

    h2 {
      color: ${theme.palette.text.main};
    }

    p {
      color: ${theme.palette.text.main};
      white-space: pre-line;
    }

    button {
      align-self: flex-end;
      min-width: 164px;
    }

    @media (max-width: ${theme.layout.breakpoints.md}) {
      max-width: 100vw;
    }
  `}
`;
